import React, { Component } from 'react';

import './index.scss';

class OverlayLoader extends Component {

    render() {

        const { width, height, text } = this.props;

        return <div className={`overlay-loader mx-auto w-${width ? width : 100} h-${height ? height : 100}`}>
            <div className="spinner-border" role="status">
                {/* <span className="sr-only">{text && text}</span> */}
            </div>
            {text && <p className="mb-0 ml-2 pt-4">{text}</p>}
        </div>
    }
}

export default OverlayLoader;